
        import * as module0 from './controllers/carousel_controller.js';import * as module1 from './controllers/crisp-chat_controller.js';import * as module2 from './controllers/mail-to_controller.js';import * as module3 from './controllers/parallax_controller.js'
        const modules = {
            "./controllers/carousel_controller.js": module0,
            "./controllers/crisp-chat_controller.js": module1,
            "./controllers/mail-to_controller.js": module2,
            "./controllers/parallax_controller.js": module3,
        };
        export default modules;
      